import { useState, useCallback } from "react";
import { QrCode } from "lucide-react";
import { Logo } from "./Logo";
import { CenterSwitcher } from "./CenterSwitcher";
import { CheckInOverlay } from "./CheckInOverlay";

export function MobileHeader() {
  const [showCheckIn, setShowCheckIn] = useState(false);
  const handleCloseCheckIn = useCallback(() => setShowCheckIn(false), []);

  return (
    <>
      <header className="sticky top-0 z-40 flex h-12 items-center justify-between border-b border-border/40 bg-bg/95 px-5 backdrop-blur-sm safe-top">
        <Logo size="sm" showDots={false} />
        <div className="flex items-center gap-2">
          <CenterSwitcher align="right" />
          <button
            data-tour="qr-checkin"
            onClick={() => setShowCheckIn(true)}
            className="p-1.5 text-muted hover:text-foreground transition-colors"
            aria-label="Check in"
          >
            <QrCode className="w-[22px] h-[22px]" />
          </button>
        </div>
      </header>
      <CheckInOverlay isOpen={showCheckIn} onClose={handleCloseCheckIn} />
    </>
  );
}
